import { ApolloError, useMutation } from "@apollo/client"
import { useAppDispatch } from "../../../store/app/hooks"
import {
  setCloseAlert,
  setLoadingDelete,
  setOpenAlert,
} from "../../../store/features/alert/alertSlice"
import { havePermissions } from "../../../utils/permissions"
import SwitchButton from "../SwitchButton/SwitchButton"
import { setOpenSnackbar } from "../../../store/features/snackbar/snackbarSlice"
import { getErrorsAsString } from "../../../utils/getErrorsAsString"
import { graphql } from "../../../gql"
import { Maybe } from "../../../gql/graphql"

const VISIBLE_CATEGORY = graphql(`
  mutation UpdateOneCategory(
    $data: CategoryUpdateInput!
    $where: CategoryWhereUniqueInput!
  ) {
    updateOneCategory(data: $data, where: $where) {
      id
      isVisible
    }
  }
`)

const ToogleVisibleCategory = ({
  isVisible,
  id,
}: {
  isVisible?: Maybe<boolean> | undefined
  id: number
}) => {
  const dispatch = useAppDispatch()
  const [visibleCategory] = useMutation(VISIBLE_CATEGORY)

  const onCompleted = () => {
    dispatch(
      setOpenSnackbar({
        message: "La modification a été faite avec succès",
        status: "success",
      }),
    )
    dispatch(setLoadingDelete(false))
    dispatch(setCloseAlert())
  }

  const onError = (err: ApolloError) => {
    const message = getErrorsAsString(err)
    dispatch(setCloseAlert())
    dispatch(setOpenSnackbar({ message, status: "error" }))
  }

  const handleToogleVisible = (id: number, isVisible: boolean) => {
    dispatch(setLoadingDelete(true))
    visibleCategory({
      variables: {
        where: { id },
        data: {
          isVisible: {
            set: !isVisible,
          },
        },
      },
      onCompleted: onCompleted,
      onError: onError,
      update(cache, { data }) {
        const dataCategory = data?.updateOneCategory
        if (dataCategory) {
          cache.modify({
            id: cache.identify({
              __typename: "Category",
              id: id,
            }),
            fields: {
              isVisible() {
                return dataCategory.isVisible
              },
            },
          })
        }
      },
    })
  }

  const handleShowAlertVisible = (id: number, isVisible: boolean) => {
    if (!havePermissions(["category.change"])) {
      dispatch(
        setOpenSnackbar({
          message: "Vous n'avez pas la permission de faire cette action",
          status: "error",
        }),
      )
    } else {
      dispatch(
        setOpenAlert({
          handleValid: () => handleToogleVisible(id, isVisible),
          message:
            "Êtes-vous vraiment sûr de vouloir modifier la statut de visibilité de cette catégorie ?",
          isLoading: false,
        }),
      )
    }
  }

  return (
    <SwitchButton
      checked={Boolean(isVisible)}
      disabled={!havePermissions(["category.change"])}
      handleChange={() => {
        if (havePermissions(["category.change"])) {
          handleShowAlertVisible(id, Boolean(isVisible))
        }
      }}
      id={`visible-${id.toString()}`}
    />
  )
}

export default ToogleVisibleCategory
